module.exports = __webpack_public_path__ + "img/logo1.34ecf338.png";